var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1.2,
    x: 2,
    y: 5.5,
    fill: "#323657",
    rx: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1.2,
    x: 1,
    y: 11.5,
    fill: "#323657",
    rx: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M6.988 1.572a.565.565 0 0 1 .577.658L5.187 16.34a.55.55 0 0 1-1.086-.182l2.35-14.113a.565.565 0 0 1 .537-.472ZM12.441 1.572a.565.565 0 0 1 .577.658L10.64 16.34a.55.55 0 0 1-1.085-.182l2.349-14.113a.565.565 0 0 1 .537-.472Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.f20e4135a406da740e5ad58b7e25cc25.svg";
export { ForwardRef as ReactComponent };